import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { registerWebMcpTools } from "./webmcp-tools";
import "./index.css";

// Register WebMCP tools as early as possible so an agent host that inspects the
// page on load sees them. Safe no-op when WebMCP is unavailable.
registerWebMcpTools();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
